<template>
    <div class="invite-public-share" v-if="showPanel" style="display: block">
        <Panel v-bind="config" @share="handleShare" />
    </div>
    <div v-else style="display: none"></div>
</template>

<script >
import { computed } from 'vue-demi';
import { Panel } from '@futuweb/growth-share-panel';
import { inviteLink, code, appDataList } from '../common/payload';
import { shareReport } from '../common/report';
import { use } from '@fegobull/webapi';
import { currentLanguage, Language, watchLanguage } from '../common/lang';
const __sfc_main = {};
__sfc_main.props = {
  // 语种
  language: {
    type: String,
    default: Language.EN
  },
  market: {
    type: String,
    default: ''
  },
  imageConfigs: {
    type: Array,
    default: () => []
  },
  descConfigs: {
    type: Array,
    default: () => []
  },
  channelConfigs: {
    type: Array,
    default: () => []
  },
  forceDisplay: {
    type: Boolean,
    default: false
  },
  displayMyCode: {
    type: Boolean,
    default: true
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useUser
  } = use;
  const props = __props;
  watchLanguage(() => props.language);
  const config = computed(() => {
    const res = {
      forceDisplay: props.forceDisplay,
      displayMyCode: +props.displayMyCode,
      language: currentLanguage.value,
      code: code.value,
      inviteLink: inviteLink.value,
      appDataList: appDataList.value,
      imageConfigs: props.imageConfigs,
      descConfigs: props.descConfigs,
      channelConfigs: props.channelConfigs
    };
    return res;
  });
  const showPanel = computed(() => {
    if (window.FEGOEditor) {
      return true;
    } else {
      const {
        isLogin
      } = useUser();
      return isLogin;
    }
  });

  // 事件上报
  function handleShare(payload) {
    shareReport({
      channel: payload.channel,
      material_id: `${payload.imageConfig?.id || ''}`,
      string_id: `${payload.descConfig?.id || ''}`,
      user_home_market: props.market
    });
  }
  return {
    config,
    showPanel,
    handleShare
  };
};
__sfc_main.components = Object.assign({
  Panel
}, __sfc_main.components);
export default __sfc_main;
</script>
<style lang="less" scoped>
.invite-public-share {
    height: auto !important;
}
</style>
